exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header[data-v-d89b63da]{background-color:transparent}.card[data-v-d89b63da]{background-color:initial}a[data-v-d89b63da]{color:inherit!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d89b63da","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/containers/large-container-expand-right.vue
// module id = 1503
// module chunks = 0